import React from 'react';
import { StarIcon } from 'lucide-react';
const facts = [{
  value: '2,500+',
  label: 'Educators across USA, UK, Canada & Australia'
}, {
  value: '6 + 6',
  label: 'Volumes and free bonuses included'
}, {
  value: '4.9/5',
  label: 'Community rating'
}, {
  value: 'All Levels',
  label: "From a student's first chords to advanced improvisation"
}];
export function SocialProofBar() {
  return <section aria-label="Social proof" className="border-y border-night-600 bg-night-900" data-id="element-304" data-mp="32jmregjbvvot">
      <div className="mx-auto grid max-w-shell grid-cols-2 gap-y-7 px-5 py-8 sm:px-6 sm:py-10 lg:grid-cols-4 lg:gap-x-8" data-id="element-305" data-mp="2xk9tn0qx547g">
        {facts.map((fact, index) => <div key={fact.value} className={`px-1 lg:px-6 ${index > 0 ? 'lg:border-l lg:border-night-600' : ''}`} data-id="element-306" data-mp="2tglnmmhxqgob" data-mpi={index}>
            <p className="flex items-center gap-2 font-display text-3xl leading-none text-amber sm:text-4xl" data-id="element-307" data-mp="1i3jg0gxtd1ga">
              {fact.value}
              {fact.value === '4.9/5' && <StarIcon className="h-4 w-4 fill-amber text-amber" aria-hidden="true" data-id="element-308" data-mp="18okmpirw7fwf" />}
            </p>
            <p className="mt-3 max-w-[15rem] text-xs leading-relaxed text-cream-muted" data-id="element-309" data-mp="1dnntb7nitu6i">{fact.label}</p>
          </div>)}
      </div>
    </section>;
}